var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEggIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 125.4",
    enableBackground: "new 0 0 120.2 125.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8932C",
    d: "M112.2,46.1C105.3,22.9,82.4,5.3,57.7,8.4c-0.1-0.2-0.3-0.2-0.6-0.2C34.5,10.8,16.2,27.3,9.6,48.7 c-0.8,2.7-1.5,5.4-2,8.2c-0.2,0.1-0.2,0.4-0.1,0.5c-0.2,1-0.3,2-0.4,3c-0.1,0.1-0.1,0.2,0,0.3C6.3,68,6.8,75.5,8.9,82.5 c0.9,2.9,2,5.6,3.5,8c0,0.2,0.1,0.4,0.3,0.5c3.9,6.5,9.5,11.7,16.1,15.9c9.8,6.3,20.6,10.6,32.4,10.4c1.3,0,2.6-0.1,3.9-0.2 c0.2,0.2,0.7,0.2,0.8-0.1c8.9-0.9,17.7-4.1,25.2-8.9c9.8-6.3,16.9-14.7,20.4-25.9C115.1,70.6,115.6,57.9,112.2,46.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.66,
    y1: 57.9267,
    x2: 114.6286,
    y2: 81.8891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0981162,
    style: {
      stopColor: "#774916"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5845,
    style: {
      stopColor: "#BE7724"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8216,
    style: {
      stopColor: "#E8932C"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M51.7,97.1l37.6,12.1c0.6-0.4,1.2-0.7,1.8-1.1c9.8-6.3,16.9-14.7,20.4-25.9 c3.1-9.9,3.9-20.6,1.9-30.8L61.7,28.7L51.7,97.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M85.1,71.9c0,13.9-11.3,25.2-25.2,25.2S34.8,85.8,34.8,71.9 S46.1,29.1,60,29.1S85.1,58,85.1,71.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E8932C",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M41.9,57.3c0,0-12.8,26.7,12,36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggIcon);
export default __webpack_public_path__ + "static/media/egg_icon.97a1ed2dd3c234866e939f21ed66d793.svg";
export { ForwardRef as ReactComponent };